/**
 * <ScrollReveal> - reusable scroll-driven reveal wrapper.
 *
 * Applies the shared `.bp-reveal` class (see scrollReveal.css), which fades +
 * rises content ~20px as it enters the viewport using CSS
 * `animation-timeline: view()`. It is a pure progressive enhancement:
 *   - Content is fully visible by default.
 *   - The reveal only activates where scroll-driven animations are supported
 *     and the user has not requested reduced motion.
 *   - The animation follows scroll position and reverses on scroll-back.
 *
 * Drop-in: wrap a section/heading/card. Does not animate nested elements
 * individually, keeping the page calm.
 */
import React from 'react';

export const ScrollReveal = ({ as: Tag = 'div', children, className = '', ...rest }) => (
  <Tag className={`bp-reveal${className ? ` ${className}` : ''}`} {...rest}>
    {children}
  </Tag>
);

export default ScrollReveal;
